import { type ThemeTypings } from '@chakra-ui/react';

import { InterviewStatus } from '@/services/api';

// eslint-disable-next-line complexity
export const statusColor = (
  Value?: string
): {
  schema: ThemeTypings['colorSchemes'];
  main: ThemeTypings['colorSchemes'];
  border: ThemeTypings['colorSchemes'];
  text: ThemeTypings['colorSchemes'];
  fade: ThemeTypings['colorSchemes'];
} => {
  if (
    Value === InterviewStatus.Added ||
    Value === InterviewStatus.PreliminaryCompleted ||
    Value === InterviewStatus.OfferSent
  ) {
    return {
      schema: 'blue',
      main: 'rgba(240, 233, 248, 0.00)',
      fade: '#F0E9F8',
      border: '#B899DF',
      text: 'primary.700',
    };
  }
  if (Value === InterviewStatus.Invited) {
    return {
      schema: 'cyan',
      main: 'rgba(1, 29, 34, 0)',
      fade: '#F0E9F8',
      border: '#CFBAE9',
      text: 'primary.200',
    };
  }

  if (Value === InterviewStatus.NotCompleted) {
    return {
      schema: 'red',
      main: 'rgb(233, 234, 237, 0.0)',
      fade: '#DEDFE2',
      border: 'gray.200',
      text: 'gray.400',
    };
  }

  if (Value === InterviewStatus.Completed) {
    return {
      schema: 'blue',
      main: 'rgba(224, 249, 237, 0.00)',
      fade: '#E0F9ED',
      border: 'success.200',
      text: 'success.300',
    };
  }

  if (Value === InterviewStatus.Evaluated) {
    return {
      schema: 'green',
      main: 'rgba(239, 211, 184, 0)',
      fade: '#EFD3B8',
      text: 'warning.500',
      border: 'warning.200',
    };
  }

  if (
    Value === InterviewStatus.Positive ||
    Value === InterviewStatus.OfferAccepted
  ) {
    return {
      schema: 'green',
      main: 'rgba(22, 153, 92,0)',
      fade: '#B7DFCC',
      text: 'green.500',
      border: 'green.400',
    };
  }

  if (
    Value === InterviewStatus.Negative ||
    Value === InterviewStatus.OfferRejected
  ) {
    return {
      schema: 'red',
      main: 'rgba(232, 114, 106, 0)',
      fade: '#F4BEBA',
      text: 'error.300',
      border: 'error.200',
    };
  }

  if (Value === InterviewStatus.Hired) {
    return {
      schema: 'teal',
      main: 'rgba(22, 153, 92, 0)',
      fade: '#B7DFCC',
      text: 'green.500',
      border: 'green.400',
    };
  }

  if (Value === InterviewStatus.Pending) {
    return {
      schema: 'yellow',
      main: 'rgba(202, 114, 25, 0)',
      fade: '#EFD3B8',
      text: 'warning.400',
      border: 'warning.300',
    };
  }

  if (Value === InterviewStatus.SentAgain) {
    return {
      schema: 'yellow',
      main: 'rgba(202, 114, 25, 0)',
      fade: '#EFD3B8',
      text: 'warning.400',
      border: 'warning.300',
    };
  }

  if (Value == 'Active') {
    return {
      schema: 'green',
      main: 'rgba(16, 156, 91, 0)',
      fade: '#B7DFCC',
      text: 'green.500',
      border: 'green.400',
    };
  }

  if (Value == 'Inactive') {
    return {
      schema: 'red',
      main: 'rgba(190, 91, 84, 0)',
      fade: '#F4BEBA',
      text: 'error.300',
      border: 'error.200',
    };
  }

  if (Value == InterviewStatus.ActionRequired) {
    return {
      schema: 'blue',
      main: 'rgba(204, 188, 222, 0)',
      fade: '#F0E9F8',
      border: '#B899DF',
      text: 'primary.700',
    };
  }

  if (
    Value === InterviewStatus.Paused ||
    Value === InterviewStatus.InTheInterview ||
    Value === InterviewStatus.Withdrawn
  ) {
    return {
      schema: 'orange',
      main: 'rgba(250, 241, 232, 0.00)',
      fade: '#FAF1E8',
      border: 'warning.200',
      text: 'warning.300',
    };
  }

  if (Value === InterviewStatus.NotInterested) {
    return {
      schema: 'red',
      main: 'rgba(232, 114, 106, 0)',
      fade: 'error.100',
      text: 'error.300',
      border: 'error.200',
    };
  }

  if (
    Value === InterviewStatus.InternalProcess ||
    Value === InterviewStatus.InternalProcessTwo ||
    Value === InterviewStatus.ReferenceCheck
  ) {
    return {
      schema: 'gray',
      main: 'gray.50',
      fade: 'gray.100',
      text: 'gray.700',
      border: 'gray.200',
    };
  }

  return { schema: '', main: '', fade: '', border: '', text: '' };
};
